import axios from "axios";

// Prefer same-origin in the browser so custom production domains (e.g. useen.ai)
// route all /api/* calls back to the same host — no cross-origin, no CORS hops,
// no leaked backend URL embedded at build-time. Falls back to REACT_APP_BACKEND_URL
// only when there is no window (SSR/Node test contexts).
const envUrl = process.env.REACT_APP_BACKEND_URL || "";
const sameOrigin =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : "";
const BACKEND_URL = sameOrigin || envUrl;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("useen_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // do not auto-redirect to allow login flow handling
    }
    return Promise.reject(err);
  }
);
